import React from 'react';
import type {CustomFontOptions} from '../../ConnectJSInterface';

export const CustomFontsContext = React.createContext<CustomFontOptions>([]);
CustomFontsContext.displayName = 'CustomFontsContext';

export const useCustomFonts = () => {
  return React.useContext(CustomFontsContext);
};
